module.exports = __webpack_public_path__ + "assets/img/datamap.caca8c86.png";